var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 24.5834V25.6667H3.25V24.5834L5.41667 22.4167V15.9167C5.41667 12.5584 7.61583 9.60091 10.8333 8.64758C10.8333 8.53925 10.8333 8.44175 10.8333 8.33341C10.8333 7.75878 11.0616 7.20768 11.4679 6.80135C11.8743 6.39502 12.4254 6.16675 13 6.16675C13.5746 6.16675 14.1257 6.39502 14.5321 6.80135C14.9384 7.20768 15.1667 7.75878 15.1667 8.33341C15.1667 8.44175 15.1667 8.53925 15.1667 8.64758C18.3842 9.60091 20.5833 12.5584 20.5833 15.9167V22.4167L22.75 24.5834ZM15.1667 26.7501C15.1667 27.3247 14.9384 27.8758 14.5321 28.2821C14.1257 28.6885 13.5746 28.9167 13 28.9167C12.4254 28.9167 11.8743 28.6885 11.4679 28.2821C11.0616 27.8758 10.8333 27.3247 10.8333 26.7501",
    fill: "#DE8D8D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.875,
    cy: 8.87492,
    r: 7.48177,
    fill: "#DE8D8D",
    stroke: "white",
    strokeWidth: 0.880208
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBell);
export default __webpack_public_path__ + "static/media/ic_bell.124dc6d5aabe80bc543054084cfb7089.svg";
export { ForwardRef as ReactComponent };